import moment from 'moment';
import React, { useEffect, useState } from 'react';
import GlobalStore from '../../stores/global-store';
import visitsApi from '../../apis/visits-api';
import Loading from '../../components/Loading/Loading';
import './Visit.css';

function Visit() {
  const [visits, setVisits] = useState([]);
  const { setLoading, affID } = GlobalStore.useContainer();
  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isChangePage, setIsChangePage] = useState(false);

  useEffect(() => {
    async function getVisits() {
      setLoading(true);
      const responseVisits = await visitsApi.getVisits(affID);
      setVisits(responseVisits.data?.visits);
      setTotalPage(responseVisits.data?.total);
      setCurrentPage(responseVisits.data?.page);
      setLoading(false);
    }

    getVisits();
  }, [setLoading]);

  const trimReferralLink = (link) => {
    if (link === '') {
      return '';
    }

    const linkPeaces = link.split('/');
    return '.../' + linkPeaces[linkPeaces.length - 2] + '/';
  };

  const handlePaginationClick = async (index) => {
    setIsChangePage(true);
    setCurrentPage(index);
    const responseVisits = await visitsApi.getVisits(affID, index);
    setVisits(responseVisits.data?.visits);
    setIsChangePage(false);
  }

  const handleNext = async () => {
    if (currentPage === totalPage) return;
    setIsChangePage(true);
    setCurrentPage(currentPage + 1);
    const responseVisits = await visitsApi.getVisits(affID, currentPage + 1);
    setVisits(responseVisits.data?.visits);
    setIsChangePage(false);
  }

  const handlePrev = async () => {
    if (currentPage === 1) return;
    setIsChangePage(true);
    setCurrentPage(currentPage - 1);
    const responseVisits = await visitsApi.getVisits(affID, currentPage - 1);
    setVisits(responseVisits.data?.visits);
    setIsChangePage(false);
  }

  const pagination = [];

  for (let i = 1; i <= totalPage; i++) {
    pagination.push(<li className={`page-item ${i === currentPage ? 'active' : ''}`}><button className="page-link" onClick={() => handlePaginationClick(i)}>{i}</button></li>);
  }

  return (
    <div className="page-visits container-fluid">
      <h2 className="mb-3">Lượng truy cập</h2>
      <table className="table-container">
        <thead>
          <tr>
            <th>Link</th>
            <th>Link giới thiệu</th>
            <th>Ngày truy cập</th>
          </tr>
        </thead>
        <tbody>
          {!isChangePage && visits && visits.length > 0 && (
            visits.map(visit => (
              <tr key={visit.visit_id}>
                <td><a href={visit.url} target="_blank" rel="noreferrer">{trimReferralLink(visit.url)}</a></td>
                <td>{visit.referral || 'Direct traffic'}</td>
                <td>{moment(visit.date).add(7, 'hours').format('DD/MM/YYYY H:m')}</td>
              </tr>
            ))
          )}
          {visits?.data?.status === 404 && (
            <tr>
              <td className="text-center text-secondary" colSpan={3}>Chưa có dữ liệu</td>
            </tr>
          )}
          {isChangePage &&
            <tr>
              <td className="text-center text-secondary" colSpan={3}><Loading color="gray" /></td>
            </tr>
          }
        </tbody>
      </table>
      {totalPage > 1 &&
        <nav ariaLabel="Page navigation">
          <ul className="pagination justify-content-center mt-3">
            <li className="page-item"><button className="page-link" onClick={handlePrev}>&#60;</button></li>
            {pagination}
            <li className="page-item"><button className="page-link" onClick={handleNext}>&#62;</button></li>
          </ul>
        </nav>
      }
    </div>
  )
}

export default Visit;
